import React, { Component } from 'react';
import { Icon } from 'antd';
import { connect } from 'react-redux';
import { logout as logoutFun } from '../../services';

class logout extends Component<any, any> {
    logout = () => {
        logoutFun();
    };
    render() {
        return (
            <div onClick={this.logout}>
                <Icon type="logout"></Icon>
                <span>登出</span>
            </div>
        );
    }
}

export const Logout = connect(null, (dispatch) => {
    return {
        // logout: () => {
        //     dispatch(actions.logoutSuccessAction());
        // },
    };
})(logout);
